/* global MutationObserver, Node, CustomEvent */
import { Controller } from '@hotwired/stimulus'

export default class LocationRefreshController extends Controller {
  connect () {
    this.initializeMutationObserver()
  }

  disconnect () {
    this.cleanupObserver()
  }

  initializeMutationObserver () {
    this.observer = new MutationObserver(this.handleMutations.bind(this))

    this.observer.observe(this.element, {
      childList: true,
      subtree: true
    })
  }

  handleMutations (mutations) {
    const addedNodesWithTimestamp = this.extractNodesWithTimestamp(mutations)

    if (addedNodesWithTimestamp.length > 0) {
      this.triggerMapRefresh(addedNodesWithTimestamp)
    }
  }

  extractNodesWithTimestamp (mutations) {
    const nodesWithTimestamp = []

    mutations.forEach(mutation => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(node => {
          if (this.hasTimestampData(node)) {
            nodesWithTimestamp.push(node)
          }
        })
      }
    })

    return nodesWithTimestamp
  }

  hasTimestampData (node) {
    return node.nodeType === Node.ELEMENT_NODE &&
           node.dataset &&
           'timestamp' in node.dataset
  }

  triggerMapRefresh (nodes) {
    const timestamps = nodes.map(node => node.dataset.timestamp).filter(Boolean)

    window.dispatchEvent(new CustomEvent('updateSearch', {
      detail: {
        forceRefresh: true,
        timestamps: timestamps
      }
    }))
  }

  cleanupObserver () {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  }
}
